<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- ===== HERO ===== -->
  <section class="relative min-h-[85vh] flex items-center pt-24 pb-16 overflow-hidden page-hero-gradient">
    <div class="absolute -top-32 right-0 w-[600px] h-[600px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]" style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;"></div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </a>
        <h1 class="hero-full font-black mb-6" data-aos="fade-up" data-aos-delay="100">
          Your Car. <span class="text-varroc-accent">Smarter.</span> Safer.
        </h1>
        <p class="text-varroc-text-gray text-xl leading-relaxed mb-10" data-aos="fade-up" data-aos-delay="200">
          Turn any vehicle into a connected, intelligent companion — with real-time insights, safety alerts, and rewards. No car replacement needed.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/store/product" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all text-lg flex items-center gap-2">
            <i class='bx bx-shopping-bag text-xl'></i> Shop Devices
          </a>
          <a routerLink="/products/connectiq" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all text-lg">
            Learn More
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== STICKY NAV ===== -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-32">

    <!-- ===== CONNECTED CAR ===== -->
    <section id="connected" class="section-anchor">
      <div class="mb-14" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Connected Car</span>
        <h2 class="text-4xl font-black mt-3 mb-4">Your Vehicle, Always Online</h2>
        <p class="text-varroc-text-gray text-lg max-w-2xl mr-auto">Know everything about your car in real-time — from where it is to how it's running — right from your smartphone.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let f of [
          {icon:'bx-map-alt', title:'Live Location', desc:'Know exactly where your vehicle is, anytime. Shared access for family members.'},
          {icon:'bx-history', title:'Trip History', desc:'Review every journey with route replay, speed timeline, and fuel consumption.'},
          {icon:'bx-health', title:'Vehicle Health', desc:'OBD diagnostics decoded into plain language — know what that warning light really means.'},
          {icon:'bx-shield-alt-2', title:'Theft Alerts', desc:'Instant notification if your car moves without your permission.'},
          {icon:'bx-time-five', title:'Idle Monitoring', desc:'Get alerted when your vehicle idles excessively — save fuel and reduce wear.'},
          {icon:'bx-trending-up', title:'Driving Score', desc:'See how safely you drive each week with personalised tips to improve.'}
        ]" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="($index * 80).toString()">
          <i class='bx icon-gradient text-2xl mb-3' [class]="f.icon"></i>
          <h3 class="text-white font-bold mb-2">{{ f.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ f.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== SAFETY ===== -->
    <section id="safety" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Safety & Alerts</span>
          <h2 class="text-4xl font-black mt-3 mb-4">Always There When It Matters Most</h2>
          <p class="text-varroc-text-gray text-base leading-relaxed mb-6">Real-time safety features that protect you and your family on every journey — automatically, without any intervention.</p>
          <div class="space-y-4">
            <div *ngFor="let item of [
              {icon:'bx-alarm-exclamation', title:'Crash Detection', desc:'Automatic crash detection with emergency contact notification.'},
              {icon:'bx-map', title:'Geo-fence Alerts', desc:'Know when your vehicle enters or exits designated zones.'},
              {icon:'bx-tachometer', title:'Overspeed Alerts', desc:'Set speed limits and get notified instantly when exceeded.'},
              {icon:'bx-moon', title:'Late Night Alerts', desc:'Be notified when your vehicle is driven late at night.'}
            ]" class="flex items-start gap-4 p-4 rounded-xl border border-varroc-border hover:border-varroc-accent/30 transition-all">
              <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i class='bx icon-gradient text-xl' [class]="item.icon"></i>
              </div>
              <div>
                <div class="text-white font-semibold text-sm mb-1">{{ item.title }}</div>
                <div class="text-varroc-text-gray text-xs">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="feature-card text-center p-10" data-aos="fade-left">
          <i class='bx bx-shield-alt-2 icon-gradient text-7xl mb-6'></i>
          <h3 class="text-white font-black text-2xl mb-3">Always Protected</h3>
          <p class="text-varroc-text-gray leading-relaxed">Our real-time safety engine monitors 40+ vehicle parameters simultaneously to keep you protected at all times.</p>
          <div class="mt-6 grid grid-cols-2 gap-3">
            <div class="bg-black/60 rounded-lg p-3 text-center">
              <div class="text-varroc-accent font-black text-xl">40+</div>
              <div class="text-varroc-text-gray text-xs">Parameters Monitored</div>
            </div>
            <div class="bg-black/60 rounded-lg p-3 text-center">
              <div class="text-varroc-accent font-black text-xl">&lt;2s</div>
              <div class="text-varroc-text-gray text-xs">Alert Delivery</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== REWARDS ===== -->
    <section id="rewards" class="section-anchor">
      <div class="mb-14" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Mobility Rewards</span>
        <h2 class="text-4xl font-black mt-3 mb-4">Get Rewarded for Safe Driving</h2>
        <p class="text-varroc-text-gray text-lg max-w-2xl mr-auto">Safe and eco-friendly driving earns you real rewards — from insurance discounts to fuel cashback and exclusive lifestyle perks.</p>
      </div>
      <!-- Rewards carousel -->
      <div class="overflow-hidden mb-10">
        <div class="carousel-track">
          <div *ngFor="let r of [
            {icon:'bx-shield-alt-2', title:'Insurance discount', desc:'Up to 30% off motor insurance'},
            {icon:'bx-gas-pump', title:'Fuel cashback', desc:'Earn points redeemable at fuel stations'},
            {icon:'bx-star', title:'Safety badge', desc:'Showcase your driving score'},
            {icon:'bx-gift', title:'Lifestyle rewards', desc:'Partner brand vouchers & discounts'},
            {icon:'bx-heart', title:'Health benefit', desc:'Wellness perks for safe drivers'},
            {icon:'bx-trophy', title:'Leaderboard', desc:'Compete with your community'},
            {icon:'bx-shield-alt-2', title:'Insurance discount', desc:'Up to 30% off motor insurance'},
            {icon:'bx-gas-pump', title:'Fuel cashback', desc:'Earn points redeemable at fuel stations'},
            {icon:'bx-star', title:'Safety badge', desc:'Showcase your driving score'},
            {icon:'bx-gift', title:'Lifestyle rewards', desc:'Partner brand vouchers & discounts'},
            {icon:'bx-heart', title:'Health benefit', desc:'Wellness perks for safe drivers'},
            {icon:'bx-trophy', title:'Leaderboard', desc:'Compete with your community'}
          ]" class="flex-shrink-0 w-56 feature-card text-center p-6">
            <i class='bx icon-gradient text-3xl mb-3' [class]="r.icon"></i>
            <h4 class="text-white font-bold text-sm mb-1">{{ r.title }}</h4>
            <p class="text-varroc-text-gray text-xs">{{ r.desc }}</p>
          </div>
        </div>
      </div>
      <div class="text-center">
        <a routerLink="/store/product" class="inline-block bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">
          Start Earning Today
        </a>
      </div>
    </section>

  </div>
</main>
